import { render, staticRenderFns } from "./EmployeePreview.vue?vue&type=template&id=be8a37fc"
import script from "./EmployeePreview.vue?vue&type=script&lang=js"
export * from "./EmployeePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports